import { useEffect, useState } from "react";
import { Loader2 } from "lucide-react";

export const Loading = () => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const t = setTimeout(() => setShow(true), 100);
    return () => clearTimeout(t);
  }, []);

  if (!show) return null;

  return (
    <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 flex flex-col items-center gap-3">
      <Loader2 className="size-10 text-primary animate-spin" aria-label="Cargando" />
      <p className="text-sm text-muted-foreground font-medium">Cargando...</p>
    </div>
  );
};
